export default {
  "https://ask-henry.whenry6688.workers.dev/view-assets/05404bab-b2a1-4f86-8006-6926206721b4": {
    "display": "/assets/view-covers/05404bab-b2a1-4f86-8006-6926206721b4-1024.webp",
    "thumbnail": "/assets/view-covers/05404bab-b2a1-4f86-8006-6926206721b4-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/62577cd6-62b5-4066-96e4-5c82380c3b06": {
    "display": "/assets/view-covers/62577cd6-62b5-4066-96e4-5c82380c3b06-1024.webp",
    "thumbnail": "/assets/view-covers/62577cd6-62b5-4066-96e4-5c82380c3b06-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/64193ede-845e-4fcd-a1a4-99a3f19c372b": {
    "display": "/assets/view-covers/64193ede-845e-4fcd-a1a4-99a3f19c372b-1024.webp",
    "thumbnail": "/assets/view-covers/64193ede-845e-4fcd-a1a4-99a3f19c372b-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/6633bacb-2481-490b-bb4f-11e241988185": {
    "display": "/assets/view-covers/6633bacb-2481-490b-bb4f-11e241988185-1024.webp",
    "thumbnail": "/assets/view-covers/6633bacb-2481-490b-bb4f-11e241988185-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/66cb031a-06ce-4ce9-97b0-7ae8ecca1f3f": {
    "display": "/assets/view-covers/66cb031a-06ce-4ce9-97b0-7ae8ecca1f3f-1024.webp",
    "thumbnail": "/assets/view-covers/66cb031a-06ce-4ce9-97b0-7ae8ecca1f3f-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/8589e24f-df1b-4c45-9d37-fdcadc97e00f": {
    "display": "/assets/view-covers/8589e24f-df1b-4c45-9d37-fdcadc97e00f-1024.webp",
    "thumbnail": "/assets/view-covers/8589e24f-df1b-4c45-9d37-fdcadc97e00f-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/8e12ce5e-da8e-4aec-8542-3948daa05bbe": {
    "display": "/assets/view-covers/8e12ce5e-da8e-4aec-8542-3948daa05bbe-1024.webp",
    "thumbnail": "/assets/view-covers/8e12ce5e-da8e-4aec-8542-3948daa05bbe-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/94c04339-99ce-47af-8949-18129249a868": {
    "display": "/assets/view-covers/94c04339-99ce-47af-8949-18129249a868-1024.webp",
    "thumbnail": "/assets/view-covers/94c04339-99ce-47af-8949-18129249a868-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/b9a09121-4e25-4969-bbe9-1e848e047527": {
    "display": "/assets/view-covers/b9a09121-4e25-4969-bbe9-1e848e047527-1024.webp",
    "thumbnail": "/assets/view-covers/b9a09121-4e25-4969-bbe9-1e848e047527-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/c4a27032-e7e5-4c8f-be2d-0e0b40a40810": {
    "display": "/assets/view-covers/c4a27032-e7e5-4c8f-be2d-0e0b40a40810-1024.webp",
    "thumbnail": "/assets/view-covers/c4a27032-e7e5-4c8f-be2d-0e0b40a40810-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/d93006bc-fea7-4aea-9cfd-72211eb1fedd": {
    "display": "/assets/view-covers/d93006bc-fea7-4aea-9cfd-72211eb1fedd-1024.webp",
    "thumbnail": "/assets/view-covers/d93006bc-fea7-4aea-9cfd-72211eb1fedd-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/f3bc4668-984c-4fc4-97b2-b3df32d283dd": {
    "display": "/assets/view-covers/f3bc4668-984c-4fc4-97b2-b3df32d283dd-1024.webp",
    "thumbnail": "/assets/view-covers/f3bc4668-984c-4fc4-97b2-b3df32d283dd-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/fd0b38ef-f645-49ba-b6e9-fa2ad016a438": {
    "display": "/assets/view-covers/fd0b38ef-f645-49ba-b6e9-fa2ad016a438-1024.webp",
    "thumbnail": "/assets/view-covers/fd0b38ef-f645-49ba-b6e9-fa2ad016a438-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/fdc08534-41bd-477f-bb94-db32d1307832": {
    "display": "/assets/view-covers/fdc08534-41bd-477f-bb94-db32d1307832-1024.webp",
    "thumbnail": "/assets/view-covers/fdc08534-41bd-477f-bb94-db32d1307832-384.webp"
  },
  "https://ask-henry.whenry6688.workers.dev/view-assets/fe30a35e-ca30-493f-9aaa-a9061a20e8ee": {
    "display": "/assets/view-covers/fe30a35e-ca30-493f-9aaa-a9061a20e8ee-1024.webp",
    "thumbnail": "/assets/view-covers/fe30a35e-ca30-493f-9aaa-a9061a20e8ee-384.webp"
  }
};
